import styles from './BarraCambiosSinGuardar.module.css';

interface Props {
  /** Normalmente el `hayCambios` de useCambiosSinGuardar. */
  visible: boolean;
  onGuardar: () => void;
  /** Si se omite, no se muestra el botón Descartar. */
  onDescartar?: () => void;
  /** Deshabilita los botones y cambia el texto mientras se guarda. */
  guardando?: boolean;
  mensaje?: string;
}

/**
 * Aviso estándar de cambios pendientes: barra fija al pie con el mensaje y los
 * botones de acción. Se usa junto con `useCambiosSinGuardar` para que todos los
 * formularios del portal avisen igual.
 *
 * Vive fija al pie a propósito: el problema real era que el botón Guardar
 * quedaba fuera de la pantalla y el usuario creía haber aplicado el cambio.
 */
export default function BarraCambiosSinGuardar({
  visible,
  onGuardar,
  onDescartar,
  guardando = false,
  mensaje = 'Tienes cambios sin guardar',
}: Props) {
  if (!visible) return null;

  return (
    <div className={styles.barra} role="status" aria-live="polite">
      <div className={styles.mensaje}>
        <span className={styles.punto} aria-hidden="true" />
        <span className={styles.texto}>{mensaje}</span>
      </div>

      <div className={styles.acciones}>
        {onDescartar && (
          <button
            type="button"
            className={`${styles.boton} ${styles.descartar}`}
            onClick={onDescartar}
            disabled={guardando}
          >
            Descartar
          </button>
        )}
        <button
          type="button"
          className={`${styles.boton} ${styles.guardar}`}
          onClick={onGuardar}
          disabled={guardando}
        >
          {guardando ? 'Guardando…' : 'Guardar cambios'}
        </button>
      </div>
    </div>
  );
}
